__turbopack_context__.v({
  "body": "rtcQKa_body",
  "card": "rtcQKa_card",
  "cards": "rtcQKa_cards",
  "content": "rtcQKa_content",
  "date": "rtcQKa_date",
  "fallback": "rtcQKa_fallback",
  "header": "rtcQKa_header",
  "remark": "rtcQKa_remark",
  "remarkIcon": "rtcQKa_remarkIcon",
  "step": "rtcQKa_step",
  "stepNumber": "rtcQKa_stepNumber",
  "steps": "rtcQKa_steps",
});
